import type { ConversationPipeline } from './api/conversation/types';

/**
 * Генерация экспертных заключений — единственная обработка, запуск которой ограничивается
 * областью (`ExpertReportPipelineScope`), поэтому её имя знает не только перечень
 * обработок, но и место, где область добавляется к запуску.
 */
export const EXPERT_REPORT_GENERATION_PIPELINE =
  'expert_report_generation_pipeline' as const satisfies ConversationPipeline;

/**
 * Общий перечень обработок, запускаемых над диалогом, в порядке показа пользователю.
 * Один источник для всех мест запуска (массовые действия над диалогами, прогрузка
 * диалогов голосового бота), чтобы наборы обработок и их подписи не расходились.
 */
export const CONVERSATION_PIPELINE_OPTIONS = [
  { value: 'raw_asr_process_pipeline', labelKey: 'common:conversationPipeline.full' },
  { value: 'raw_asr_process_pipeline_no_llm', labelKey: 'common:conversationPipeline.noLlm' },
  { value: EXPERT_REPORT_GENERATION_PIPELINE, labelKey: 'common:conversationPipeline.expertReport' },
  { value: 'extract_raw_attributes_pipeline', labelKey: 'common:conversationPipeline.extractRawAttributes' },
  { value: 'extract_attributes_pipeline', labelKey: 'common:conversationPipeline.extractAttributes' },
] as const satisfies readonly { value: ConversationPipeline; labelKey: string }[];

/**
 * Загрузка данных калькулятора — обработка, предлагаемая только при включённой интеграции
 * `c1_crm_calculator`, поэтому она стоит вне общего перечня {@link CONVERSATION_PIPELINE_OPTIONS}:
 * места запуска, не проверяющие интеграцию, предлагать её не должны.
 */
export const C1_CRM_CALCULATOR_PIPELINE_OPTION = {
  value: 'c1_crm_calculator_fetch',
  labelKey: 'common:conversationPipeline.c1CrmCalculator',
} as const satisfies { value: ConversationPipeline; labelKey: string };
